"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const auth_events_1 = __importDefault(require("./auth.events"));
const env_1 = require("./utils/env");
const event_agent_1 = require("./utils/event.agent");
const session_monitor_1 = __importStar(require("./session.monitor"));
const event_tracker_1 = __importDefault(require("./event.tracker"));
const event_listeners_1 = require("./event.listeners");
const localStorage_1 = require("./utils/localStorage");
const AUTH_DEFAULT_ROUTE = '/';
const AUTH_REDIRECT_STORAGE = 'AUTH_REDIRECT_STORAGE';
const AUTH_STORAGE = 'cas-js:user';
const SIGNIN_SILENT_CALLBACK_PARAM = 'signinSilentCallback';
const BOOSTRAP_CONFIG_DEFAULT_OPTIONS = {
    appName: '',
    forceSilentByRedirect: false,
    onRedirect: (url) => window.location.href = url,
    signinRedirect: true,
    revalidateOnFocus: true,
    revalidateOnStart: true,
    revalidateOnReconnect: true
};
class Bootstrap {
    constructor(authService, config) {
        this.config = Object.assign(Object.assign({}, BOOSTRAP_CONFIG_DEFAULT_OPTIONS), config);
        this.config.forceSilentByRedirect = this.config.forceSilentByRedirect || env_1.isCustomDomain;
        this.authService = authService;
        this.subject = new rxjs_1.Subject();
        this.subscribe = this.subject.subscribe.bind(this.subject);
        this.unsubscribe = this.subject.unsubscribe.bind(this.subject);
        this.localStorageManager = new localStorage_1.LocalStorageManager();
        this.eventTracker = new event_tracker_1.default(this.authService, this.config.appName);
        this.sessionMonitor = new session_monitor_1.default(this.authService, this.eventTracker);
        this.authRenewRoute = new URL(this.authService.userManager.settings.silent_redirect_uri).pathname;
        this.authLoginRoute = new URL(this.authService.userManager.settings.redirect_uri).pathname;
        this.authLogoutRoute = new URL(this.authService.userManager.settings.post_logout_redirect_uri).pathname;
        this.authRoutes = [this.authRenewRoute, this.authLoginRoute, this.authLogoutRoute];
        this.isRevalidating = false;
        this.listenerManager = new event_listeners_1.ListenerManager(this.authService.userManager.events, Object.assign(Object.assign({}, this.config), this.authService.userManager.settings), this.eventTracker);
        this.accessTokenExpiringListener = () => {
            this.eventTracker.setLevel(event_agent_1.LEVEL.INFO);
            this.eventTracker.setReason(event_agent_1.REASON.RENEW);
            this.eventTracker.setOrigin(this.authService.getAuthority());
            auth_events_1.default.dispatchRenew();
        };
        this.accessTokenExpiredListener = () => {
            this.eventTracker.setLevel(event_agent_1.LEVEL.INFO);
            this.eventTracker.setReason(event_agent_1.REASON.RENEW);
            this.eventTracker.setOrigin(this.authService.getAuthority());
            auth_events_1.default.dispatchRenew();
        };
        this.silentRenewErrorListener = (error) => {
            this.eventTracker.setLevel(event_agent_1.LEVEL.ERROR);
            this.eventTracker.setReason(event_agent_1.REASON.RENEW);
            this.eventTracker.setOrigin(this.authService.getAuthority());
            auth_events_1.default.dispatchRenewError(error);
        };
        this.focusListener = () => {
            this.eventTracker.setReason(event_agent_1.REASON.FOCUS);
            console.info('[CAS-JS][onFocus]', document.visibilityState);
            if (document.visibilityState === 'visible') {
                this.revalidate();
            }
        };
        this.onlineListener = () => {
            this.eventTracker.setReason(event_agent_1.REASON.ONLINE);
            this.authenticate();
        };
        this.userLoadedListener = () => {
            this.eventTracker.setLevel(event_agent_1.LEVEL.SUCCESS);
            this.eventTracker.setOrigin(window.location.origin);
            if (location.pathname === this.authLoginRoute)
                this.getUser();
            else
                this.authenticate();
        };
        this.userUnloadedListener = () => {
            this.eventTracker.setLevel(event_agent_1.LEVEL.SUCCESS);
            this.eventTracker.setOrigin(window.location.origin);
        };
        this.listenerManager.setHandler('accessTokenExpiring', this.accessTokenExpiringListener.bind(this), event_listeners_1.RaiseEvent.ONCE);
        this.listenerManager.setHandler('accessTokenExpired', this.accessTokenExpiredListener.bind(this), event_listeners_1.RaiseEvent.ONCE);
        this.listenerManager.setHandler('silentRenewError', this.silentRenewErrorListener.bind(this), event_listeners_1.RaiseEvent.ONCE);
        this.listenerManager.setHandler('userLoaded', this.userLoadedListener.bind(this));
        this.listenerManager.setHandler('userUnloaded', this.userUnloadedListener.bind(this));
        this.listenerManager.setHandler('online', this.onlineListener.bind(this), event_listeners_1.RaiseEvent.NEVER);
        this.listenerManager.setHandler('focus', this.focusListener.bind(this), event_listeners_1.RaiseEvent.NEVER);
    }
    start(newConfig = {}) {
        try {
            this.eventTracker.setReason(event_agent_1.REASON.INIT);
            this.config = Object.assign(Object.assign({}, this.config), newConfig);
            this.authService.isSigninSilentByRedirect = this.config.forceSilentByRedirect && !this.config.signinRedirect;
            this.authenticate();
            if (this.authService.userManager.settings.automaticSilentRenew) {
                this.authService.userManager.startSilentRenew();
                this.authService.userManager.events.addSilentRenewError(this.silentRenewErrorListener);
            }
            this.listenerManager.start(Object.assign(Object.assign({}, this.config), this.authService.userManager.settings));
        }
        catch (error) {
            this.subject.error({ origin: '[CAS start]', error });
        }
    }
    stop() {
        try {
            if (this.authService.userManager.settings.automaticSilentRenew) {
                this.authService.userManager.stopSilentRenew();
            }
            this.listenerManager.stop();
        }
        catch (error) {
            this.subject.error({ origin: '[CAS stop]', error });
        }
    }
    authenticate() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const url = new URL(location.href);
                let signinSilentCallback = url.searchParams.get(SIGNIN_SILENT_CALLBACK_PARAM);
                if (this.authService.isSigninSilentByRedirect && signinSilentCallback) {
                    this.sessionMonitor.callback();
                    auth_events_1.default.dispatchRenewError(new Error(signinSilentCallback));
                    url.searchParams.delete(SIGNIN_SILENT_CALLBACK_PARAM);
                    history.replaceState({}, '', url.href);
                    return;
                }
                if (location.pathname === this.authRenewRoute && window.self !== window.top) {
                    return yield this.authService.signinSilentCallback();
                }
                if (this.sessionMonitor.isResponseRoute()) {
                    auth_events_1.default.dispatchRenew();
                    this.sessionMonitor.response();
                }
                if (location.pathname === this.authRenewRoute || location.pathname === this.authLoginRoute) {
                    try {
                        signinSilentCallback = yield this.authService.signinCallback();
                    }
                    catch (error) {
                        this.signinRedirect();
                    }
                }
                if (location.pathname === this.authLogoutRoute) {
                    this.authService.isSignoutSilent() ? yield this.authService.signoutSilentCallback()
                        : yield this.authService.signoutCallback();
                    const redirectRoute = sessionStorage.getItem(AUTH_REDIRECT_STORAGE);
                    this.config.onRedirect(redirectRoute || AUTH_DEFAULT_ROUTE);
                    return;
                }
                if (this.authRoutes.indexOf(location.pathname) >= 0) {
                    const redirectRoute = sessionStorage.getItem(AUTH_REDIRECT_STORAGE) || AUTH_DEFAULT_ROUTE;
                    const redirectUrl = new URL(location.origin + redirectRoute);
                    if (this.authService.isSigninSilentByRedirect && typeof signinSilentCallback === 'string') {
                        redirectUrl.searchParams.set(SIGNIN_SILENT_CALLBACK_PARAM, signinSilentCallback);
                    }
                    this.config.onRedirect(redirectUrl.href);
                    sessionStorage.removeItem(AUTH_REDIRECT_STORAGE);
                    return;
                }
                if (this.config.revalidateOnStart) {
                    const user = yield this.revalidate();
                    if (user || this.isRevalidating)
                        return;
                }
                this.getUser();
            }
            catch (error) {
                this.subject.error({ origin: '[CAS authenticate]', error });
            }
        });
    }
    signinSilent() {
        return __awaiter(this, void 0, void 0, function* () {
            let user;
            try {
                user = yield this.authService.getUser();
                this.eventTracker.setLevel(event_agent_1.LEVEL.INFO);
                this.eventTracker.setOrigin(window.location.origin);
                this.eventTracker.send(user ? event_agent_1.EVENT_NAME.RENEWING : event_agent_1.EVENT_NAME.SIGNING_SILENT);
                auth_events_1.default.dispatchRenew();
                return yield this.authService.signinSilent();
            }
            catch (error) {
                this.eventTracker.setLevel(event_agent_1.LEVEL.ERROR);
                this.eventTracker.setOrigin(this.authService.getAuthority());
                this.eventTracker.send(user ? event_agent_1.EVENT_NAME.RENEW_ERROR : event_agent_1.EVENT_NAME.SIGNIN_SILENT_ERROR, { detail: error.message });
                auth_events_1.default.dispatchRenewError(error);
                this.signinRedirect();
                this.subject.error({ origin: '[CAS signinSilent]', error });
                return null;
            }
        });
    }
    signinRedirect() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!this.config.signinRedirect && !this.authService.isSigninSilentByRedirect)
                    return;
                const currRoute = this.getCurrentRoute();
                localStorage.removeItem(AUTH_STORAGE);
                sessionStorage.setItem(AUTH_REDIRECT_STORAGE, currRoute);
                yield this.authService.signinRedirect();
            }
            catch (error) {
                this.subject.error({ origin: '[CAS signinRedirect]', error });
            }
        });
    }
    /**
     * @description Logs out the current user silently (without redirect).
     * @param {SignoutRequestArgs} args The targeted id_token_hint to be logged out.
     */
    signoutSilent(args) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.authService.signoutSilent(args);
        });
    }
    getUser() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let user = yield this.authService.getUser();
                if (!user)
                    yield this.signinRedirect();
                if ((user === null || user === void 0 ? void 0 : user.expired) || (!user && !this.config.signinRedirect))
                    user = yield this.signinSilent();
                this.setUser(user);
                return user;
            }
            catch (error) {
                this.subject.error({ origin: '[CAS getUser]', error });
            }
        });
    }
    setUser(user) {
        return __awaiter(this, void 0, void 0, function* () {
            auth_events_1.default.dispatchUser(user);
            if (!user)
                return;
            localStorage.setItem(AUTH_STORAGE, JSON.stringify(user));
            this.subject.next(user);
        });
    }
    logout(error) {
        return __awaiter(this, void 0, void 0, function* () {
            const reason = error ? event_agent_1.REASON.API_ERROR : event_agent_1.REASON.USER;
            this.eventTracker.setLevel(event_agent_1.LEVEL.INFO);
            this.eventTracker.setReason(reason);
            if (reason === event_agent_1.REASON.API_ERROR && !this.sessionMonitor.isResponseRoute()) {
                if (this.isRevalidating)
                    return;
                const user = yield this.authService.getUser();
                const session = yield this.revalidate();
                this.eventTracker.setOrigin(error.origin);
                if (session === session_monitor_1.sessionStatus.REDIRECT) {
                    this.sessionMonitor.setLogoutPayload({ reason, error, user });
                    return;
                }
                if (session === session_monitor_1.sessionStatus.INVALID) {
                    this.eventTracker.setReason(event_agent_1.REASON.INVALID_SESSION);
                }
            }
            try {
                const currRoute = this.getCurrentRoute();
                localStorage.removeItem(AUTH_STORAGE);
                sessionStorage.setItem(AUTH_REDIRECT_STORAGE, currRoute);
                this.eventTracker.send(event_agent_1.EVENT_NAME.LOGOUT);
                yield this.authService.signoutRedirect();
            }
            catch (error) {
                this.subject.error({ origin: '[CAS logout]', error });
            }
        });
    }
    // eslint-disable-next-line max-len
    revalidate() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isRevalidating)
                return;
            this.isRevalidating = true;
            auth_events_1.default.dispatchRenew();
            // Session monitor flow
            const currRoute = this.getCurrentRoute();
            sessionStorage.setItem(AUTH_REDIRECT_STORAGE, currRoute);
            const session = yield this.sessionMonitor.validate(this.config.signinRedirect);
            this.eventTracker.setLevel(event_agent_1.LEVEL.INFO);
            this.eventTracker.setOrigin(this.sessionMonitor.baseUrl);
            if (session === session_monitor_1.sessionStatus.REDIRECT) {
                return session;
            }
            if (session === session_monitor_1.sessionStatus.VALID) {
                const user = yield this.authService.getUser();
                this.eventTracker.send(event_agent_1.EVENT_NAME.VALID_SESSION);
                auth_events_1.default.dispatchUser(user);
                this.isRevalidating = false;
                return;
            }
            this.eventTracker.send(event_agent_1.EVENT_NAME.INVALID_SESSION);
            console.info('[CAS][revalidate] - signinSilent');
            // Get current user from server
            const user = yield this.signinSilent();
            this.setUser(user);
            this.isRevalidating = false;
            console.info('[CAS][revalidate] - user', user);
            return user;
        });
    }
    getCurrentRoute() {
        return this.authRoutes.indexOf(location.pathname) < 0
            ? `${location.pathname}${location.search}`
            : AUTH_DEFAULT_ROUTE;
    }
}
exports.default = Bootstrap;
